<div class="page-container">
  <app-back-link link="/settings" label="Back to Settings"></app-back-link>
  <app-page-header
    title="Processing Pipeline"
    description="Documents every stage of async data processing — what triggers it, what it produces, and how jobs are tracked.">
  </app-page-header>

  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>

  <div class="error-panel" *ngIf="error">{{ error }}</div>

  <div class="guide-content" *ngIf="content" [innerHTML]="content | markdown"></div>
</div>
